<template>
  <div class="asd20-factoid-group">
    <asd20-factoid
      v-for="(factoid, index) in factoids"
      :key="index"
      :value="factoid.value"
      :label="factoid.label"
      :prefix="factoid.prefix"
      :suffix="factoid.suffix"
      :start="factoid.start"
      :end="factoid.end"
      :once="factoid.once"
      :decimals="factoid.decimals"
      :duration="factoid.duration"
      :options="factoid.options"
    />
    <slot />
  </div>
</template>

<script>
import Asd20Factoid from '../../../components/atoms/Asd20Factoid'

export default {
  name: 'Asd20FactoidGroup',
  components: { Asd20Factoid },
  model: {
    prop: 'factoids',
  },
  props: {
    factoids: { type: Array, default: () => [] },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_variables.scss';
@import '../../../design/_mixins.scss';

$factoid-rule: var(--website-page__alternate-background-t80);

.asd20-factoid-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  box-shadow: 0px -1px 0 0 $factoid-rule;
  background: var(--color__tertiary);

  &::v-deep .asd20-factoid {
    box-shadow: 1px -1px 0 0 $factoid-rule inset;
    width: 50%;

    &:nth-child(2n + 1) {
      background-position-y: bottom;
    }

    &:nth-child(3n + 1) {
      background-position-x: 100%;
    }

    &:nth-child(4n + 1) {
      background-position-y: center;
    }

    &:first-child:nth-last-child(odd) ~ .asd20-factoid:last-child {
      flex-grow: 1;
      width: auto;
    }
  }
}

@media (min-width: 1024px) {
  .asd20-factoid-group {
    .asd20-factoid {
      width: 25%;

      &:first-child:nth-last-child(2),
      &:first-child:nth-last-child(2) ~ .asd20-factoid {
        width: calc(100% / 2);
      }

      &:first-child:nth-last-child(3),
      &:first-child:nth-last-child(3) ~ .asd20-factoid,
      &:first-child:nth-last-child(6),
      &:first-child:nth-last-child(6) ~ .asd20-factoid {
        width: calc(100% / 3);
      }

      &:first-child:nth-last-child(7),
      &:first-child:nth-last-child(7) ~ .asd20-factoid {
        width: calc(100% / 4);
      }
      &:first-child:nth-last-child(7) ~ .asd20-factoid:nth-child(n + 6) {
        width: calc(100% / 3);
      }
    }
  }
}
</style>
